(function () {
  const drawer = document.getElementById('formula-drawer');
  if (!drawer) return;

  /** @type {HTMLElement | null} */
  let triggerEl = null;

  const openDrawer = (/** @type {Event} */ e) => {
    triggerEl = /** @type {HTMLElement} */ (e.currentTarget);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = /** @type {HTMLElement | null} */ (drawer.querySelector('.formula-drawer__close'));
    if (closeBtn) closeBtn.focus();
  };

  const closeDrawer = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (triggerEl) triggerEl.focus();
  };

  document.querySelectorAll('[data-open-formula-drawer]').forEach((el) => {
    el.addEventListener('click', openDrawer);
  });

  drawer.querySelectorAll('[data-close-formula-drawer]').forEach((el) => {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  drawer.querySelectorAll('.formula-drawer__accordion-toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const body = /** @type {HTMLElement | null} */ (toggle.nextElementSibling);
      if (!body) return;
      toggle.setAttribute('aria-expanded', String(!expanded));
      body.classList.toggle('formula-drawer__accordion-body--closed', expanded);
    });
  });
})();